import { render, staticRenderFns } from "./checkPrescReportType.vue?vue&type=template&id=326533be&scoped=true&"
import script from "./checkPrescReportType.vue?vue&type=script&lang=js&"
export * from "./checkPrescReportType.vue?vue&type=script&lang=js&"
import style0 from "./checkPrescReportType.vue?vue&type=style&index=0&id=326533be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326533be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('326533be')) {
      api.createRecord('326533be', component.options)
    } else {
      api.reload('326533be', component.options)
    }
    module.hot.accept("./checkPrescReportType.vue?vue&type=template&id=326533be&scoped=true&", function () {
      api.rerender('326533be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/components/checkPrescReportType.vue"
export default component.exports